import MarketingLayout from "@/components/layout/MarketingLayout";
import { Card } from "@/components/ui/card";

function LegalPage({ title, updated, body }) {
  return (
    <MarketingLayout>
      <section className="page-shell px-6 py-20">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">{title}</div>
          <h1 className="font-display text-5xl mt-3 leading-tight">{title}</h1>
          <div className="text-xs text-muted-foreground mt-3">Last updated: {updated}</div>
        </div>
        <Card className="mt-10 p-8 rounded-3xl prose prose-neutral max-w-none dark:prose-invert">
          {body}
        </Card>
      </section>
    </MarketingLayout>
  );
}

export function Privacy() {
  return (
    <LegalPage title="Privacy Policy" updated="February 2026" body={
      <div className="space-y-4 text-sm">
        <p>Finzpe respects your privacy. This policy describes what information we collect, how we use it, and the choices you have.</p>
        <h3 className="font-display text-lg">Information we collect</h3>
        <p>Personal identifiers (name, email, phone, address), KYC identifiers (Aadhaar, PAN — masked), employment and income data, and product usage data.</p>
        <h3 className="font-display text-lg">How we use it</h3>
        <p>To evaluate loan applications, provide customer support, prevent fraud, and meet legal obligations. We do not sell personal data.</p>
        <h3 className="font-display text-lg">Security</h3>
        <p>Data is encrypted at rest and in transit. Access is role-based and audit-logged. Retention is limited to what regulations require.</p>
        <h3 className="font-display text-lg">Your choices</h3>
        <p>You may request access, correction, or deletion of your data by writing to <a href="mailto:privacy@finzpe.com" className="text-primary underline">privacy@finzpe.com</a>.</p>
      </div>
    } />
  );
}

export function Terms() {
  return (
    <LegalPage title="Terms & Conditions" updated="February 2026" body={
      <div className="space-y-4 text-sm">
        <p>These terms govern your use of Finzpe's website and services. By using our services, you agree to these terms.</p>
        <h3 className="font-display text-lg">Eligibility</h3>
        <p>Services are available to Indian residents aged 21–60 who meet our internal underwriting criteria.</p>
        <h3 className="font-display text-lg">Fees & interest</h3>
        <p>All fees, interest and charges are disclosed on your sanction letter. Late payments attract charges as detailed there.</p>
        <h3 className="font-display text-lg">Approvals</h3>
        <p>Loan decisions and disbursals are configurable business workflows. Finzpe reserves the right to accept or reject any application.</p>
        <h3 className="font-display text-lg">Communications</h3>
        <p>By registering, you consent to receive service communications via email, SMS, WhatsApp and phone.</p>
      </div>
    } />
  );
}

export function Disclaimer() {
  return (
    <LegalPage title="Disclaimer" updated="February 2026" body={
      <div className="space-y-4 text-sm">
        <p>Content on this website is for informational purposes only. Nothing on this website should be construed as guaranteed loan approval, guaranteed disbursement, or an offer to lend.</p>
        <p>Illustrative figures (customers, disbursals, ratings) are for demonstration and may not reflect actuals.</p>
        <p>Loan decisions, verification, approval and disbursement are represented as configurable business workflows and may vary by product and applicant.</p>
      </div>
    } />
  );
}
